'use client';

import { usePageShippingRules } from '@/lib/context/shippingEligibilityContext';

export default function ShippingRulesWatcher() {
  usePageShippingRules();
  return null;
}
